import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import './app-data-grid.css';

const DEFAULT_PAGE_SIZES = [10, 25, 50, 100];

function AppDataGrid({
  height = 700,
  width = '100%',
  rowsPerPageOptions = DEFAULT_PAGE_SIZES,
  density = 'standard',
  className = '',
  sx,
  ...props
}) {
  return (
    <div className={`app-data-grid ${className}`} style={{ height, width }}>
      <DataGrid
        density={density}
        rowsPerPageOptions={rowsPerPageOptions}
        disableColumnMenu
        disableSelectionOnClick
        sx={sx}
        {...props}
      />
    </div>
  );
}

export default AppDataGrid;
